import { createContext, useContext } from 'react';

/**
 * The room token is needed wherever an avatar photo is rendered. Held in
 * context rather than threaded through every layout component; the design
 * gallery renders outside a room and gets null.
 */
export const RoomTokenContext = createContext<string | null>(null);

export function useRoomToken(): string | null {
  return useContext(RoomTokenContext);
}
